import { trackRemoveFromCart } from '@jbhi-fi/utils/src/ga4Tracking';
import { transformCartItemForTracking } from './transformCartItemForTracking';
import { getStoreCurrency } from '../shopify/getStoreCurrency';
import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export const trackRemoveFromCartShopify = async (removedItem: JbCartItem | undefined) => {
  if (!removedItem) return;
  trackRemoveFromCart({
    currency: getStoreCurrency(),
    removedItem: transformCartItemForTracking(removedItem),
  });
};
